// extracted by mini-css-extract-plugin
module.exports = {"top_bar_wrapper":"vericar_top_bar_wrapper__2N_3l","logo_svg":"vericar_logo_svg__21fR8"};